import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { routes } from '@/lib/routes';
import { LoadingScreen } from '@/components/common/LoadingScreen';

/**
 * Redirige desde `/` según rol y estado:
 * - sin sesión → /login
 * - APEX → /select-empresa (o a su última si hubiera persistencia, por ahora siempre select)
 * - resto → /e/:empresa_id_propia/dashboard
 * - administrador sin administracion_id → fallback a /login (edge case, shouldn't happen)
 */
export function RootRedirect() {
  const { session, profile, loading, isApex } = useAuth();

  if (loading) return <LoadingScreen />;
  if (!session) return <Navigate to={routes.login} replace />;
  if (!profile) return <LoadingScreen message="Preparando tu panel…" />;

  if (isApex) return <Navigate to={routes.selectEmpresa} replace />;

  if (profile.empresa_id) {
    return <Navigate to={routes.empresa.dashboard(profile.empresa_id)} replace />;
  }

  // Edge case: profile sin empresa (ni APEX) → ningún lugar a donde ir
  return (
    <div className="grid min-h-screen place-items-center px-6">
      <div className="card-premium max-w-md p-8 text-center">
        <p className="kicker mb-2">Cuenta sin empresa</p>
        <h2 className="mb-2 text-xl font-extrabold tracking-tight">Esperá un momento.</h2>
        <p className="text-sm text-neutral-muted">
          Tu cuenta todavía no está asignada a una empresa. Avisale al administrador para
          que complete tu alta.
        </p>
      </div>
    </div>
  );
}
